import Vue from 'vue'
import App from './App.vue'
import router from './router'
import api from './api'
import store from './store'
import Vuetify from 'vuetify/lib'
import VueTheMask from 'vue-the-mask'

Vue.use(VueTheMask)
Vue.use(Vuetify)

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#9bbf33'
      }
    }
  }
})

Vue.config.productionTip = false
Vue.use(api, store, router)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
